import axios from 'axios';
import type { Collection } from './types/collection';
import type { Artwork } from './types/artwork';
// import { artworks } from './data/artworks'; local files

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export const getHomepageData = async (): Promise<unknown> => {
  const response = await api.get('/home');
  return response.data;
};

// Don't use if you don't want to use the database
export const getArtworks = async (): Promise<Artwork[]> => {
  const token = localStorage.getItem('token');

  const response = await api.get('/admin/artworks', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const mappedArtworks: Artwork[] = response.data.map((item: any) => ({
    id: item.id,

    title: {
      en: item.title?.en ?? item.title_en ?? '',
      ro: item.title?.ro ?? item.title_ro ?? '',
    },

    short_description: {
      en:
        item.short_description?.en ??
        item.short_description_en ??
        '',
      ro:
        item.short_description?.ro ??
        item.short_description_ro ??
        '',
    },

    description: {
      en: item.description?.en ?? item.description_en ?? '',
      ro: item.description?.ro ?? item.description_ro ?? '',
    },

    price: Number(item.price ?? 0),

    image_url: item.image_url ?? item.imageUrl ?? '',
    imageUrl: item.imageUrl ?? item.image_url ?? '',

    heightCm: item.heightCm ?? item.height_cm ?? 0,
    widthCm: item.widthCm ?? item.width_cm ?? 0,
    depthCm: item.depthCm ?? item.depth_cm ?? 0,

    is_featured: item.is_featured ?? item.isFeatured ?? false,
    is_sold: item.is_sold ?? item.isSold ?? false,

    image_count:
      item.image_count ??
      item.imageCount ??
      item.images?.length ??
      0,

    is_public_ready:
      item.is_public_ready ??
      item.isPublicReady ??
      false,

    catalogue_number:
      item.catalogue_number ??
      item.catalogueNumber ??
      null,

    images:
      item.images?.map((image: any) => ({
        url: image.image_url,
        public_id: image.public_id,
        width: image.width,
        height: image.height,
        thumbnail_url: image.thumbnail_url,
        large_url: image.large_url,
      })) ?? [],

    created_at: item.created_at ?? item.createdAt ?? '',
    updated_at: item.updated_at ?? item.updatedAt ?? '',
  }));

  console.log('Mapped artworks:', mappedArtworks);

  return mappedArtworks;
};
// Use the file store instead with the code below
// export const getArtworks = async (): Promise<Artwork[]> => {
//   return artworks;
// };

export const getArtwork = async (id: string): Promise<Artwork> => {
  const response = await api.get<Artwork>(`/artworks/${id}`);
  return response.data;
};

export const getAboutContent = async (): Promise<{ title: string; content: string }> => {
  const response = await api.get<{ title: string; content: string }>('/content/about');
  return response.data;
};

export default api;